import { render, staticRenderFns } from "./NewMember.vue?vue&type=template&id=2cc0c71a&scoped=true&"
import script from "./NewMember.vue?vue&type=script&lang=js&"
export * from "./NewMember.vue?vue&type=script&lang=js&"
import style0 from "./NewMember.vue?vue&type=style&index=0&id=2cc0c71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0c71a",
  null
  
)

export default component.exports